import { PCRChannels } from '@enums'
import { IPCRPerformanceMap } from '@store/postCampaignReport'

export const submissionPerformanceMap: Record<string, ReadonlyArray<IPCRPerformanceMap>> = {
  [PCRChannels.Facebook]: [
    { key: 'fb.post.followers', prop: 'followers' },
    { key: 'fb.post.likes', prop: 'likes' },
    { key: 'fb.post.comments', prop: 'comments' },
    { key: 'fb.post.shares', prop: 'shares' },
    { key: 'fb.post.engagement', prop: 'engagement', showTooltip: true },
    {
      key: 'fb.post.engagementRate',
      prop: 'engagement_rate',
      showTooltip: true,
      showPercentSign: true,
    },
    { key: 'fb.post.costPerEngagement', prop: 'cost_per_engagement', showTooltip: true },
    { key: 'fb.post.purchaseAmount', prop: 'purchase_amount', showTooltip: true },
  ],
}
